module.exports = __webpack_public_path__ + "img/typhoon.03c7916f.svg";